import { useContext } from 'react';
import { ClubContext } from '@/features/clubs/context/ClubContextDefinition';
import type { ClubContextType } from '@/features/clubs/context/ClubContextDefinition';

export const useClubContext = (): ClubContextType => {
  const context = useContext(ClubContext);
  if (context === undefined) {
    throw new Error('useClubContext must be used within a ClubProvider');
  }
  return context;
};
